import React from 'react'

function SavedCart(props) {
  return(
    <div className={props.cartSaved ? "Cart-saved" : "Cart-saved hidden"}>
      <p>Abonnemanget har sparats</p>
    </div>
  )
}

export default SavedCart



// WEBPACK FOOTER //
// ./src/components/SavedCart.jsx